module.exports = __webpack_public_path__ + "img/60_M2_make_me_fat.11a3e5e8.jpg";